// File: /store/v.js
import { create } from 'zustand';
import axios from 'axios';

const useCampaignStore = create((set) => ({
  campaigns: [],

  fetchCampaigns: async () => {
    try {
      const res = await axios.get('https://stores.comart.in:3001/api/get-orders');
      set({ campaigns: res.data });
    } catch (error) {
      console.error('Failed to fetch campaigns', error);
    }
  },

  addCampaign: (campaign) =>
    set((state) => {
      axios
        .post('https://stores.comart.in:3001/api/save-order', campaign, {
          headers: { 'Content-Type': 'application/json' },
        })
        .catch(console.error);

      return { campaigns: [...state.campaigns, campaign] };
    }),

  updateItemStatus: (campaignId, itemId, newStatus) =>
    set((state) => {
      const updatedCampaigns = state.campaigns.map((campaign) =>
        campaign.id === campaignId
          ? {
              ...campaign,
              items: campaign.items.map((item) =>
                item.id === itemId ? { ...item, status: newStatus } : item
              ),
            }
          : campaign
      );
      return { campaigns: updatedCampaigns };
    }),
}));

export default useCampaignStore;
